<template>
<div id="domicilio" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Datos de la Organización" class="elevation-1 px-5 py-3" >
                    <v-flex x12 s6 m6 l6 style="text-align:right" >
                        
                        <v-btn :disabled="model.id_datos_clientes <= 0" to="/clientes/vinculados" text color="secondary" >
                            <v-icon>launch</v-icon>Ver Domicilios Vinculados
                        </v-btn>
                    </v-flex>
                    <v-card-text>
                        <v-card-title>
                            <span class="headline" ></span>
                        </v-card-title>
                        <v-form ref="form" lazy-validation>
                            <v-container grid-list-md text-xs-center @keyup.enter="guardarDomicilio()" >
                                <v-layout row wrap>
                                    <v-flex s12 m12 l12>
                                        <v-autocomplete :loading="loadingTipos" :items="tipos" v-model="model_cliente.tipos_empresa" label="Tipo Industria" item-text="nombre" item-value="id_tipo_empresa" single-line :rules="[rules.required]" ></v-autocomplete>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>                                    
                                    <v-flex s12 m6 l6>
                                        <v-text-field name="domicilio" label="Calle y Número" type="text" v-model="model.domicilio" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                    </v-flex>
                                    <v-flex s12 m6 l6>
                                        <v-text-field name="colonia" label="Colonia" type="text" v-model="model.colonia" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex s12 m6 l6>
                                        <v-text-field name="ciudad" label="Ciudad" type="text" v-model="model.ciudad" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                    </v-flex>
                                    <v-flex s12 m6 l6>
                                        <v-text-field name="codigo_postal" label="CP" type="text" v-model="model.codigo_postal" :rules="[rules.required]" maxlength="5" ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex s12 m6 l6>
                                        <v-autocomplete v-model="model.pais" :items="paises" :hide-no-data="true" :hide-selected="true" :return-object="true" item-text="nombre" item-value="id_pais" label="Selecciona un País" :rules="[rules.required]" ></v-autocomplete>
                                    </v-flex>
                                    <v-flex s12 m6 l6>
                                        <v-text-field label="Estado" type="text" v-model="model.estado_nombre" maxlength="150" ></v-text-field>                                        
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex s12 m6 l6>
                                        <v-text-field name="contacto" label="Nombre de Contacto" type="text" v-model="model.nombre_contacto" :rules="[rules.required]" maxlength="150" ></v-text-field>
                                    </v-flex>
                                    <v-flex s12 m6 l6>
                                        <v-text-field name="email_contacto" label="Email de Contacto" type="text" v-model="model.email_contacto" :rules="[rules.required, rules.email]" maxlength="50" ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex s12 m6 l6>
                                        <v-text-field name="tel1" label="Número de teléfono 1" type="text" v-model="model.telefono_1" :rules="[rules.numeric]" maxlength="15" ></v-text-field>
                                    </v-flex>
                                    <v-flex s12 m6 l6>
                                        <v-text-field name="tel2" label="Número de teléfono 2" type="text" v-model="model.telefono_2" :rules="[rules.numeric]" maxlength="15" ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                        <v-row style="margin: 10px;">
                            <v-col sm="12" md="6">
                                <v-row>
                                    <v-col>
                                        <h5><b>E-Key: </b> {{ekey}}</h5><br>
                                        <h5 v-if="api_key!=''"><b>Key de Conexión con API: </b> {{api_key}}</h5>
                                    </v-col>
                                </v-row>                                
                                <v-row>
                                    <v-col sm="12" md="6">
                                        <input type="file" style="display: none" ref="logo_input" accept=".png" @change="onLogoPicked">
                                        <v-card class="mx-auto" style="margin: 0;">
                                            <v-card-title>
                                                <b>Logotipo</b>
                                                <v-spacer></v-spacer>
                                                <v-btn small color="secondary" @click="abrir_modal_logotipo" 
                                                    :loading="load_logotipo"
                                                    title="Agregar Logotipo">
                                                    <v-icon>mdi-plus</v-icon>
                                                </v-btn>
                                            </v-card-title>                                            
                                            <div id="logo_div">                                                
                                                <img v-if="logotipo"  :src="logotipo" width="95%" style="width: 95% !important; height: auto;">
                                            </div>
                                            <span>Seleccione una imagen <strong>png</strong></span>
                                        </v-card>
                                        
                                    </v-col>
                                </v-row>
                            </v-col>                            
                            <v-col sm="12" md="6">
                                <v-card class="mx-auto" style="margin: 0;">
                                    <v-card-title>
                                        <b>Adjuntos</b>
                                        <v-spacer></v-spacer>
                                        <v-btn small color="secondary" @click="abrir_modal_adjuntos">
                                        <v-icon>mdi-plus</v-icon>
                                        </v-btn>
                                    </v-card-title>
                                    <hr>
                                    <div id="datagrid">

                                        <v-client-table ref="vuetable" :data="items_adjuntos" :columns="columns_adjuntos" :options="options_adjuntos" class="elevation-2 pa-2">
                                            <template slot="fecha_actualizacion" slot-scope="props" >
                                                <div class="text-number" >
                                                {{ props.row.fecha_actualizacion.toString().substr(0,10)}}
                                                </div>
                                            </template>
                                            
                                            <template slot="noResults">
                                                <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                                            </template>

                                            <template slot="actions" slot-scope="props">
                                                <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                                <template v-slot:activator>
                                                    <v-btn :id="props.row.id" x-small fab dark color="primary">
                                                    <v-icon>reorder</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-btn x-small fab dark color="green" @click.native="descargar_adjunto(props.row.adjunto)" title="Descargar Adjunto" v-tippy>
                                                    <v-icon>mdi-download</v-icon>
                                                </v-btn>
                                                
                                                <v-btn x-small fab dark color="blue" @click.native="abrir_modal_update(props.row.id, props.row.nombre, props.row.orden)" title="Editar Adjunto" v-tippy>
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                                <v-btn x-small fab dark color="pink" @click.native="deleteAdjunto(props.row.id)" title="Eliminar Adjunto" v-tippy>
                                                    <v-icon>delete</v-icon>
                                                </v-btn>
                                                </v-speed-dial>
                                            </template>
                                        </v-client-table>
                                    </div>
                                </v-card>
                            </v-col>
                        </v-row>
                        
                    </v-card-text>
                    <v-card-actions>
                                                
                        <v-spacer></v-spacer>

                        <v-btn color="success" @click="guardarDomicilio" :loading="loading" >
                            <v-icon>done</v-icon> Actualizar
                        </v-btn>
                    </v-card-actions>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>

    <v-dialog v-model="modal_adjuntos" max-width="30%" style=" z-index: 400 !important;">
        <v-card>
        <v-card-title>
            <v-card class="primary white--text titulomodal">
            <v-icon class="white--text" @click.native="modal_adjuntos = false">cancel</v-icon>&nbsp;
            <span class="subheading">
                <strong>Adjuntar Documento</strong>
            </span>
            </v-card>

        </v-card-title>
        <v-form ref="form_adjuntos" lazy-validation>
            <v-card-text>
            <br>
            <v-container fluid grid-list-md text-xs-center @keyup.enter="guardar_adjunto">
                <v-row row wrap>
                <v-col sm="12">
                    <v-text-field label="Orden" v-model="model_adjuntos.orden" :rules="[rules.required]" v-mask="'##'"></v-text-field>
                </v-col>
                <v-col sm="12">
                    <v-text-field label="Nombre" v-model="model_adjuntos.nombre_nuevo" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col class="d-flex" cols="12" sm="12">
                    <v-text-field label="Selecciona el archivo" @click='pickFile' v-model='model_adjuntos.nombre' :rules="[rules.required]" :readonly="true" prepend-icon='attach_file'></v-text-field>
                    <input type="file" style="display: none" ref="file_input" accept=".pdf" @change="onFilePicked">
                </v-col>
                </v-row>
            </v-container>
            </v-card-text>
        </v-form>
        <v-card-actions>
            <v-btn @click.native="modal_adjuntos = false;">
            <v-icon>cancel</v-icon> Cancelar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" :loading="loading" @click.native="guardar_adjunto">
            <v-icon>done</v-icon>
            Guardar
            </v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="modal_update" max-width="30%" style=" z-index: 400 !important;">
        <v-card>
        <v-card-title>
            <v-card class="primary white--text titulomodal">
            <v-icon class="white--text" @click.native="modal_update = false">cancel</v-icon>&nbsp;
            <span class="subheading">
                <strong>Cambiar Nombre</strong>
            </span>
            </v-card>

        </v-card-title>
        <v-form ref="form_adjuntos" lazy-validation>
            <v-card-text>
            <br>
            <v-container fluid grid-list-md text-xs-center @keyup.enter="update_adjunto">
                <v-row row wrap>
                <v-col sm="12">
                    <v-text-field label="Orden" v-model="model_update.orden" :rules="[rules.required]" v-mask="'##'"></v-text-field>
                </v-col>
                <v-col sm="12">
                    <v-text-field label="Nombre" v-model="model_update.nombre" :rules="[rules.required]"></v-text-field>
                </v-col>
                </v-row>
            </v-container>
            </v-card-text>
        </v-form>
        <v-card-actions>
            <v-btn @click.native="modal_update = false;">
            <v-icon>cancel</v-icon> Cancelar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" :loading="loading" @click.native="update_adjunto">
            <v-icon>done</v-icon>
            Guardar
            </v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import axios from "axios";

export default {
    components: {},
    data: () => ({
        rfc:"",
        logotipo:null,
        load_logotipo:false,
        items_adjuntos:[],
        columns_adjuntos: [
            'nombre',
            'fecha_actualizacion',
            'actions'
        ],
        options_adjuntos: {
            columnsClasses: {
                'nombre': 'ancho'
            },
            filterable: [],
            sorteable: [],
            headings: {
                "nombre": "Ajunto",
                "fecha_actualizacion": "Fecha Actualización",
                "actions": "Operaciones"
            },
        },
        model_adjuntos: {},
        modal_adjuntos: false,
        model_update: {},
        modal_update: false,
        api_key:"",
        fab: false,
        ekey:"",
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Organización",
                disabled: true,
                to: ""
            },
            {
                text: "Datos de la Organización",
                disabled: true,
                to: ""
            }
        ],
        loading: false,
        update: false,
        loadingTipos: true,
        tipos: [],
        model_cliente:{
            id_cliente: "",
            tipos_empresa: "",
        },
        model: {
            id_datos_clientes: 0,
            cliente: 0,
            domicilio: "",
            colonia: "",
            ciudad: "",
            estado: "",
            estado_nombre: "",
            pais: "",
            nombre_contacto: "",
            email_contacto: "",
            telefono_1: "",
            telefono_2: "",
            codigo_postal: ""
        },
        rules: {
            required: v => !!v || "Este campo es requerido",
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "Correo electrónico no valido";
            },
            numeric: value => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            }
        },
        paises: [],
        estados: []        
    }),

    methods: {
        guardarDomicilio() {
            const datos = {
                cliente: this.model.cliente,
                domicilio: this.model.domicilio,
                colonia: this.model.colonia,
                ciudad: this.model.ciudad,
                estado: (this.model.estado!=null && this.model.estado!="" && this.model.estado!=undefined) ? this.model.estado.id_estado : '',
                estado_nombre: this.model.estado_nombre,
                pais: this.model.pais.id_pais,
                nombre_contacto: this.model.nombre_contacto,
                email_contacto: this.model.email_contacto,
                telefono_1: this.model.telefono_1,
                telefono_2: this.model.telefono_2,
                codigo_postal: this.model.codigo_postal
            };

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var metodo = "post";
                var urlCliente = this.$hostname + "datos-clientes/";
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.model.id_datos_clientes + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.updateCliente();                        
                    })
                    .catch(error => {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos"
                            //showConfirmButton: false,
                        });
                        this.$root.$dialogLoader.hide();
                        console.log(error);
                    });
            }
        },

        cargarPaises: function () {
            axios
                .get(this.$hostname + "paises/")
                .then(res => {
                    if (typeof res.data !== "undefined") this.paises = res.data;
                    else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de países",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de países.",
                        footer: ""
                    });
                    console.log(err);
                });
        },

        cargarPaisSeleccionado: function (id_pais) {
            axios
                .get(this.$hostname + "paises/" + id_pais + "/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.model.pais = res.data;                        
                    } else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se encontró el país guardado en el domicilio",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el país del domiclio.",
                        footer: ""
                    });
                    console.log(err);
                });
        },

        cargarDomicilio: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                cliente: this.model.cliente
            };
            axios
                .post(this.$hostname + "datos-clientes/get_domicilio_cliente/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.model = res.data;
                        this.cargarPaisSeleccionado(res.data.pais);
                        this.update = true; //Significa, que ya tiene datos y hay que actualizarlos
                    }
                })
                .catch(err => {
                    if (typeof err.response.data.mensaje == "undefined") {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener los datos de la organización.",
                            footer: ""
                        });
                        console.log(err);
                    }
                }).then(()=>{
                    this.$root.$dialogLoader.hide();
                });
        }, 
        getCliente: function (id) {                        
            axios
                .get(this.$hostname + "clientes/" + id + "/")                
                .then(response => {
                    this.model_cliente = response.data;  
                    this.ekey = encodeURIComponent(this.$crypto.encrypted(this.model_cliente.identificador));                  
                })
                .catch(error => {                    
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el cliente",
                        footer: ""
                    });
                });
        },
        updateCliente: function () {  
            var datos= {
                id_cliente: this.model_cliente.id_cliente,
                tipos_empresa: this.model_cliente.tipos_empresa
            }
            
            if(this.model_cliente.grupo != null && this.model_cliente.grupo != "" && this.model_cliente.grupo != undefined) {
                datos['grupo'] = this.model_cliente.grupo;
            }
            axios
                .put(this.$hostname + "clientes/" + this.model_cliente.id_cliente + "/", datos)                
                .then(response => {                    
                    this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "Los datos se actualizaron correctamente.",
                        footer: ""
                    });                    
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los grupos.",
                        footer: ""
                    });
                }).then(()=>{
                    this.$root.$dialogLoader.hide();                    
                    this.$router.push("/home");
                });
            
        },
        getTipos: function () {
            axios.get(this.$hostname + "catalogos/tipos_empresas/get_tipos/")
            .then(response => {
                this.tipos = response.data;                    
            })
            .catch(error => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los tipos.",
                    footer: ""
                });                    
            }).then(()=>{
                this.loadingTipos = false;
            });
        },

        getApiKey: function(id_cliente){
            axios.post(this.$apiReportes + "api/get_api_key/",{"id_cliente":id_cliente})            
                .then(response => {
                this.api_key = response.data["api_key"];          
                })
                .catch(error => {
                console.log("Error ApiKey: ", error);
                this.api_key = "";
                });
            },
        cargarAdjuntos: function() {
            axios
                .post(this.URL + "get_adjuntos_cliente/", {
                    "id": this.$local_storage.get("id_cliente"),
                    "tipo": 2
                })
                .then(res => {
                if (typeof res.data !== "undefined") {
                    this.items_adjuntos = res.data;
                    this.$root.$dialogLoader.hide();
                }
                })
                .catch(err => {

                console.log(err);
                this.$root.$dialogLoader.hide();
                });
        },
        deleteAdjunto: function(id_registro) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                axios.post(this.URL + "borrar_adjunto_cliente/", {
                    "id": id_registro
                }).then(response => {
                    this.$swal({
                    type: "success",
                    title: "Operación Exitosa",
                    text: "El registro se eliminó correctamente.",
                    //position: 'bottom-end',
                    //timer: 3000,
                    //showConfirmButton: false,
                    footer: ""
                    });
                }).catch(error => {
                    this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al eliminar el registro",
                    footer: ""
                    });
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.cargarAdjuntos();
                });
                }
            });
        },
        guardar_adjunto: function() {
            if (!this.$refs.form_adjuntos.validate()) {
                return;
            }
            this.modal_adjuntos = false;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var self = this;
            var keyFile = this.$local_storage.get("rfc") + "/soluciona31/adjuntos/" + Date.now() + "_" + this.model_adjuntos.nombre;

            var datos = {
                key: keyFile,
                bucket: "production.econnect.ds",
                type: this.model_adjuntos.type
            }

            axios.post(this.$hostname + 's3/upload_url/', datos).then((res) => {
                if (typeof res.data !== 'undefined') {
                    var urlput = res.data.mensaje;
                    axios.put(urlput, this.model_adjuntos.archivo, {
                        headers: {
                        'Content-Type': this.model_adjuntos.type
                        }
                    })
                    .then((res) => {
                        self.guardar_key(keyFile);
                    })
                    .catch((error) => {
                        this.$root.$dialogLoader.hide();
                        this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                        footer: '',
                        });
                        console.log(error);
                    });

                } else {
                    this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                    footer: '',
                    });
                }
                })
                .catch((error) => {
                var mensaje = "Ocurrió un error al cargar el archivo. Intente nuevamente por favor.";
                if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                    mensaje = error.response.data.mensaje;
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: mensaje,
                    footer: '',
                });
                console.log(error);
                this.$root.$dialogLoader.hide();
                });
        },
        guardar_key: function(key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .post(this.URL + "guardar_adjunto_cliente/", {
                    "id_cliente": this.model_adjuntos.id,
                    "adjunto": key,
                    "nombre": this.model_adjuntos.nombre_nuevo,
                    "orden": this.model_adjuntos.orden,
                    "tipo": 2
                })
                .then(res => {
                this.$swal({
                    type: "success",
                    title: "¡Operación Exitosa!",
                    text: "El archivo se cargo correctamente",
                    footer: ""
                });
                })
                .catch(err => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al subir el archivo",
                    footer: ""
                });
                }).then(() => {
                this.$root.$dialogLoader.hide();
                this.cargarAdjuntos();
                });
        },
        update_adjunto: function() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .post(this.URL + "update_adjunto_cliente/", this.model_update)
                .then(res => {
                this.$swal({
                    type: "success",
                    title: "¡Operación Exitosa!",
                    text: "El registro se actualizó correctamente",
                    footer: ""
                });
                })
                .catch(err => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al actualizar",
                    footer: ""
                });
                }).then(() => {
                this.$root.$dialogLoader.hide();
                this.cargarAdjuntos();
                this.modal_update = false;
                });
        },
        abrir_modal_adjuntos: function() {
            this.model_adjuntos = {
                "id": this.$local_storage.get("id_cliente"),
                "archivo": null,
                "nombre": null,
                "type": null,
                "nombre_nuevo": null,
                "orden": null
            };

            this.modal_adjuntos = true;
        },
        pickFile() {
            this.$refs.file_input.click()
        },
        abrir_modal_logotipo(){
            this.$refs.logo_input.click();
        },
        onFilePicked(e) {
            try {
                const files = e.target.files;

                if (files[0] !== undefined) {

                this.model_adjuntos.nombre = files[0].name;
                this.model_adjuntos.type = files[0].type;
                this.model_adjuntos.archivo = files[0]

                }
            } catch (error) {
                console.log(error);
                this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
                footer: ""
                });
            }
        },
        cargar_logo: function(){
            this.load_logotipo = true;
            var datos = {
                id: this.rfc+"/logo_"+this.rfc+".png", //default
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then(async (res) => {
                    if (typeof res.data !== 'undefined') {
                        try {
                            const response = await fetch(res.data.mensaje); //url de S3 para descargar el logo
                            const blob = await response.blob();
                            this.logotipo = URL.createObjectURL(blob); // crea una URL temporal para <img>
                        } catch (error) {
                            console.error("Error al descargar la imagen:", error);
                        }
                    }
                }).catch((error)=>{        
                    this.load_logotipo = false;
                })
                .then(() => {                    
                    this.load_logotipo = false;
                });
        },
        onLogoPicked(e) {
            try {
                const files = e.target.files;

                if (files[0] !== undefined) {

                    var logo = files[0];
                    var type = files[0].type;
                    var key = this.rfc+"/logo_"+this.rfc+".png"; //default
                    //TODO: mandar el logotipo a guardar en S3 y mostrarlo en el div de logotipo
                    var datos = {
                        key: key,
                        bucket: "production.econnect.ds",
                        type: type
                    }
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios.post(this.$hostname + 's3/upload_url/', datos)
                    .then((res) => {
                        if (typeof res.data !== 'undefined') {
                            var urlput = res.data.mensaje;
                            //console.log(urlput);
                            axios.put(urlput, logo, {headers:{'Content-Type': type}})
                            .then((res) => {
                                this.cargar_logo();
                            })
                            .catch((error)=>{                                
                                this.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: "Ocurrió un erro al cargar el logotipo en S3. Favor de intentar nuevamente.",
                                    footer: '',
                                });
                                console.log(error);
                            }).then(()=>{
                                this.$root.$dialogLoader.hide();
                            });

                        } else {
                            this.$root.$dialogLoader.hide();
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un erro al cargar el logotipo en S3. Favor de intentar nuevamente.",
                                footer: '',
                            });
                        }
                    })
                    .catch((error) => {
                        var mensaje = "Ocurrió un error al cargar el archivo. Favor de comunicarse con soporte.";
                        if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                            mensaje = error.response.data.mensaje;
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: '',
                        });
                        console.log(error);
                        this.$root.$dialogLoader.hide();
                    });
                    

                }
            } catch (error) {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
                    footer: ""
                });
            }
        },
        descargar_adjunto: function(key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                if (typeof res.data !== 'undefined') {
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = res.data.mensaje;
                    a.target = "_blank";
                    a.click();
                    a.parentNode.removeChild(a);

                } else {
                    this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                    footer: '',
                    });
                }
                })
                .catch((error) => {
                var mensaje = "Ocurrió un error al descargar el archivo";
                if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                    mensaje = error.response.data.mensaje;
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: mensaje,
                    footer: '',
                });
                console.log(error);
                }).then(() => {
                this.$root.$dialogLoader.hide();
                });
        },
        abrir_modal_update: function(id_registro, nombre, orden) {
            this.model_update = {
                "id": id_registro,
                "nombre": nombre,
                "orden": orden
            };

            this.modal_update = true;
        }

    }, //methods
    created: function () {
        this.URL = this.$hostname + "catalogos/clientes_certificaciones/";
        this.loading = false;
        this.model.cliente = this.$local_storage.get("id_cliente");
        this.rfc = this.$local_storage.get("rfc");
        this.getTipos();
        this.getCliente(this.model.cliente);
        this.cargarPaises();
        this.cargarDomicilio();
        this.getApiKey(this.model.cliente);
        this.cargarAdjuntos();
        this.cargar_logo();
    }
};
</script>
<style>
    .ancho {
    width: 90% !important;
    }
</style>
